import React, { useEffect, useState, useCallback } from 'react';
import { GameProvider, useGame, FASES } from './context/GameContext';
import HomeScreen       from './components/HomeScreen';
import ModeSelectScreen from './components/ModeSelectScreen';
import OnlineLobby      from './components/OnlineLobby';
import SetupGame        from './components/SetupGame';
import PlayerScreen     from './components/PlayerScreen';
import AnswerInput      from './components/AnswerInput';
import ResultsScreen    from './components/ResultsScreen';
import VotingScreen     from './components/VotingScreen';
import FinalScreen      from './components/FinalScreen';
import TopBar           from './components/TopBar';
import AdBanner         from './components/AdBanner';
import SplashScreen     from './components/SplashScreen';
import { PalavraRevealScreen, PalavraDiscussaoScreen } from './components/PalavraSecretaScreens';
import { FaccaoRevealScreen, FaccaoDiscussaoScreen }   from './components/DuasFaccoesScreens';
import { NotaRevealScreen, NotaDiscussaoScreen, NotaAdivinharScreen, NotaResultadoScreen } from './components/NotaScreens';
import { MusicaDJScreen, MusicaResultadoScreen }       from './components/MusicaScreens';
import { MegaSenhaRevealScreen, MegaSenhaTurnoScreen, MegaSenhaResultadoScreen } from './components/SenhaScreens';
import { initAdMob, prepararIntersticial, mostrarIntersticial, isNative } from './services/AdMobService';
import './styles.css';

const VERSAO_ATUAL = "1.2";
const API_BASE_APP = process.env.REACT_APP_API_URL || "https://app.vitornorton.com.br/impostor-api";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.norton.descubraoimpostor";

function ModalAtualizacao({ onFechar }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.85)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: "24px 24px calc(env(safe-area-inset-bottom, 0px) + 24px)",
    }}>
      <div style={{
        background: '#1a1a2e', borderRadius: 16,
        padding: 28, maxWidth: 340, width: '100%',
        border: '2px solid #ff6b35', textAlign: 'center',
      }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>🎮</div>
        <h2 style={{ color: '#ff6b35', margin: '0 0 8px', fontSize: '1.3rem' }}>Nova versão disponível!</h2>
        <p style={{ color: '#aaa', margin: '0 0 24px', fontSize: 14 }}>
          Atualize o app para ter acesso às novidades e correções.
        </p>
        <button className="btn btn-primary" style={{ width: '100%', marginBottom: 10 }}
          onClick={() => window.open(PLAY_STORE_URL, '_blank')}>
          Atualizar agora
        </button>
        {onFechar && (
          <button className="btn btn-secondary" style={{ width: '100%' }} onClick={onFechar}>
            Agora não
          </button>
        )}
      </div>
    </div>
  );
}

const FASES_COM_BANNER = [
  FASES.HOME, FASES.MODE_SELECT, FASES.SETUP,
  FASES.PLACAR_FINAL, FASES.NOTA_RESULTADO,
  FASES.MUSICA_RESULTADO, FASES.MEGASENHA_RESULTADO,
];

function Router() {
  const { fase, irParaOnline, irParaHome, irParaModeSelect, irParaSetupComModo } = useGame();

  useEffect(() => {
    if (fase === FASES.PLACAR_FINAL && isNative()) {
      mostrarIntersticial();
    }
  }, [fase]);

  const renderTela = () => {
    switch (fase) {
      case FASES.HOME:              return <HomeScreen onSelectLocal={irParaModeSelect} onSelectOnline={irParaOnline} />;
      case FASES.MODE_SELECT:       return <ModeSelectScreen onSelectMode={irParaSetupComModo} onBack={irParaHome} />;
      case FASES.ONLINE:            return <OnlineLobby onBack={irParaHome} />;
      case FASES.SETUP:             return <SetupGame />;
      case FASES.PERGUNTA_JOGADOR:  return <PlayerScreen />;
      case FASES.RESPOSTA_JOGADOR:  return <AnswerInput />;
      case FASES.RESULTADOS:        return <ResultsScreen />;
      case FASES.VOTACAO:           return <VotingScreen />;
      case FASES.PLACAR_FINAL:      return <FinalScreen />;
      case FASES.PALAVRA_REVEAL:    return <PalavraRevealScreen />;
      case FASES.PALAVRA_DISCUSSAO: return <PalavraDiscussaoScreen />;
      case FASES.FACCAO_REVEAL:     return <FaccaoRevealScreen />;
      case FASES.FACCAO_DISCUSSAO:  return <FaccaoDiscussaoScreen />;
      case FASES.NOTA_REVEAL:       return <NotaRevealScreen />;
      case FASES.NOTA_DISCUSSAO:    return <NotaDiscussaoScreen />;
      case FASES.NOTA_ADIVINHAR:    return <NotaAdivinharScreen />;
      case FASES.NOTA_RESULTADO:    return <NotaResultadoScreen />;
      case FASES.MUSICA_DJ:         return <MusicaDJScreen />;
      case FASES.MUSICA_RESULTADO:  return <MusicaResultadoScreen />;
      case FASES.MEGASENHA_REVEAL:  return <MegaSenhaRevealScreen />;
      case FASES.MEGASENHA_TURNO:   return <MegaSenhaTurnoScreen />;
      case FASES.MEGASENHA_RESULTADO: return <MegaSenhaResultadoScreen />;
      default: return <HomeScreen onSelectLocal={irParaModeSelect} onSelectOnline={irParaOnline} />;
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <TopBar />
      <div style={{ flex: 1 }}>
        {renderTela()}
      </div>
      {FASES_COM_BANNER.includes(fase) && <AdBanner position="bottom" />}
    </div>
  );
}

export default function App() {
  const [splashOk, setSplashOk] = useState(false);
  const [mostrarAtualizacao, setMostrarAtualizacao] = useState(false);

  useEffect(() => {
    if (!splashOk) return;
    fetch(`${API_BASE_APP}/api/version?v=${VERSAO_ATUAL}`)
      .then(r => r.json())
      .then(data => {
        if (data.precisaAtualizar === true) {
          setMostrarAtualizacao(data.forcar === true ? "forcar" : true);
        }
      })
      .catch(() => {});
  }, [splashOk]);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark');

    async function init() {
      if (isNative()) {
        // Configura StatusBar para NÃO sobrepor o app
        try {
          const { StatusBar, Style } = await import('@capacitor/status-bar');
          await StatusBar.setOverlaysWebView({ overlay: false });
          await StatusBar.setStyle({ style: Style.Dark });
          await StatusBar.setBackgroundColor({ color: '#0a0a0f' });
        } catch (e) {
          console.warn('StatusBar:', e);
        }

        // Inicializa AdMob
        try {
          await initAdMob();
          await prepararIntersticial();
        } catch (e) {
          console.warn('AdMob:', e);
        }
      }
    }

    init();
  }, []);

  const handleSplashFinish = useCallback(() => {
    setSplashOk(true);
  }, []);

  if (!splashOk) {
    return <SplashScreen onFinish={handleSplashFinish} />;
  }

  return (
    <GameProvider>
      {mostrarAtualizacao && <ModalAtualizacao onFechar={mostrarAtualizacao === "forcar" ? null : () => setMostrarAtualizacao(false)} />}
      <Router />
    </GameProvider>
  );
}
